import { Component, ViewContainerRef, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { IToolbarItem } from '@shared/interfaces/toolbar-item.interface';
import { DialogService } from 'primeng/dynamicdialog';
import { PrinterConfigModalComponent } from '../printer-config-modal/printer-config-modal.component';
import { Store, select } from '@ngrx/store';
import { loadPrinter, resetPrinterIgnore } from 'src/app/store/printer/printer.actions';
import { printerFeatureKey, PrinterState, selectPrinterState } from 'src/app/store/printer/printer.reducer';
import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { UtilsService } from '@shared/services/utils.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  providers: [DialogService]
})


export class ToolbarComponent implements OnInit, OnDestroy {

  isConnected$: Observable<boolean>;
  isIgnored$: Observable<boolean>;
  private stateSubscription: Subscription | null = null;

  constructor(
    public dialogService: DialogService,
    private store: Store<{ [printerFeatureKey]: PrinterState }>,
    private utils: UtilsService,
    private cdr: ChangeDetectorRef
  ) {
    this.isConnected$ = this.store.pipe(select(printerFeatureKey, 'isConnected'));
    this.isIgnored$ = this.store.pipe(select(printerFeatureKey, 'isIgnored'));
  }

  public toolbarMenuItems: Array<IToolbarItem> = [

  ];

  ngOnInit(): void {
    this.toolbarMenuItems.push({
      icon: 'assets/icons/icon_home.png',
      title: 'INICIO',
      route: '/panel/dashboard',
      color: '#4554a8',
      titleColor: '#FFFFFF',
    });
    this.toolbarMenuItems.push({
      icon: 'assets/icons/icon_bookings.png',
      title: 'RESERVAS',
      route: '/panel/bookings',
      color: '#FFFFFF',
      titleColor: '#FFFFFF'
    });
    this.toolbarMenuItems.push({
      icon: 'assets/icons/icon_cash.png',
      title: 'CAJA',
      route: '/panel/payments',
      color: '#FFFFFF',
      titleColor: '#FFFFFF'
    });
    this.toolbarMenuItems.push({
      icon: 'assets/icons/icon_planning.png',
      title: 'PLANNING',
      route: '/panel/planning',
      color: '#FFFFFF',
      titleColor: '#FFFFFF'
    });
    this.toolbarMenuItems.push({
      icon: 'assets/icons/icon_inventory.png',
      title: 'INVENTARIOS',
      route: '/panel/inventories',
      color: '#FFFFFF',
      titleColor: '#FFFFFF'
    });
    if(this.utils.validatePermission('see_graphs_page')){
      this.toolbarMenuItems.push({
        icon: 'assets/icons/icon_service.png',
        title: 'ESTADÍSTICAS',
        route: '/panel/graphics',
        color: '#FFFFFF',
        titleColor: '#FFFFFF'
      });
    }

    const printerName = localStorage.getItem('printerDevice');

    // Despachar loadPrinter primero para intentar la conexión
    this.store.dispatch(loadPrinter());

    // Si no hay impresora configurada, abrir el modal de configuración
    // Pero solo si realmente no hay configuración guardada
    if (!printerName) {
      console.log('ToolbarComponent: No hay impresora configurada, abriendo modal de configuración');
      // Usar setTimeout para asegurarse de que la UI esté lista
      // setTimeout(() => {
      //   this.openPrinterConfigModal();
      // }, 500);
    } else {
      console.log('ToolbarComponent: Se encontró configuración de impresora:', printerName);
      console.log('ToolbarComponent: Se intentará conectar automáticamente sin mostrar el modal');
    }

    // Suscribirse al estado de la impresora usando la función de depuración para logs
    this.stateSubscription = this.store.pipe(select(selectPrinterState)).subscribe(printerState => {
      // Solo logging, no modificamos ningún botón
      const isConnected = printerState.isConnected;
      const isIgnored = printerState.isIgnored;
      const printerName = localStorage.getItem('printerDevice');

      console.log('Estado de la impresora actualizado:');
      console.log('isConnected:', isConnected);
      console.log('isIgnored:', isIgnored);
      console.log('Nombre de impresora en localStorage:', printerName);
    });
  }

  ngOnDestroy(): void {
    if (this.stateSubscription) {
      this.stateSubscription.unsubscribe();
    }
  }

  openPrinterConfigModal(): void {
    // Verificar si la impresora está en modo ignorado
    let isIgnored = false;
    this.isIgnored$.pipe(take(1)).subscribe(ignored => {
      isIgnored = ignored;
    });

    // Si está en modo ignorado y el usuario hace clic en el botón naranja,
    // resetear el estado ignorado y abrir el modal de configuración normalmente
    if (isIgnored) {
      console.log('Reseteando estado de impresora ignorada');
      this.store.dispatch(resetPrinterIgnore());

      // Configuración común del diálogo
      const dialogConfig = {
        header: 'Configurar Impresora',
        width: '70%',
        contentStyle: { overflow: 'auto' },
        baseZIndex: 10000,
        maximizable: false
      };

      // Abrir el modal
      this.dialogService.open(PrinterConfigModalComponent, dialogConfig);
    } else {
      // Si no está en modo ignorado, comportamiento normal
      const dialogConfig = {
        header: 'Configurar Impresora',
        width: '70%',
        contentStyle: { overflow: 'auto' },
        baseZIndex: 10000,
        maximizable: false
      };

      // Abrir el modal
      this.dialogService.open(PrinterConfigModalComponent, dialogConfig);
    }
  }
}
